import type { DriverEntity } from '@/features/driver/domain/entities/DriverEntity'
import type { JobStatus } from '../enums/JobStatus'
import type { RegionEntity } from '@/features/region/domain/entities/RegionEntity'

export class JobFilterEntity {
  region?: RegionEntity
  statuses?: Array<JobStatus>
  driver?: DriverEntity
  branchSid?: number
  date?: Date[]
  page?: number
  limit?: number
}
